'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.entries === 'function' ? Object.entries : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/object.entries/polyfill.js
// module id = ./node_modules/object.entries/polyfill.js
// module chunks = 0 1